import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as State from '@shared/state';

import { TilesComponent } from '../../tiles.shared.component';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

@Component({
    selector: 'shared-tile-for-reward',
    templateUrl: './tile-for-reward.shared.component.html',
    styleUrls: ['./tile-for-reward.shared.component.scss']
})
export class TileForRewardComponent extends TilesComponent implements OnInit {
    @Input() public reward: APICommon.IMemberFreeProductModel;
    @Input() public btnSize: OLO.Components.BUTTON_SIZE = 'xs';

    public image$: Observable<State.IFreeProductImage>;

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
        if (this.reward) {
            this.image$ = this.controllers.images.getImageForFreeProduct$(this.reward.ProductId);
        }
    }

    public handleClick($event: Event): void {
        this.controllers.loyalty.openModalForReward(this.reward.FreeProductId);
    }

    public get showImage$(): Observable<boolean> {
        return of(this.reward)
            .pipe(
                switchMap(reward => {
                    if (!reward) return of(true);

                    return this.controllers.images.getImageForFreeProduct$(this.reward.ProductId)
                        .pipe(
                            map(image => image === undefined
                                || image.isDownloading === true
                                || image.data !== null
                            )
                        );
                })
            );
    }
}
